import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DatatableColumn, DatatableMultiData, DatatableOptions} from './cbj-datatable.models';
import {MenuItem} from '../menu';
import {HttpClient} from '@angular/common/http';
import { ScrollbarService, WindowService } from '../scroll/index';
import {collapse} from '../animations/index';
import {Subject} from 'rxjs/Subject';

const /** @type {?} */ DEFAULTS: DatatableOptions = {
  data: null,
  columns: null,
  serverSide: false,
  multiData: false,
  classes: '',
  cardClasses: '',
  rowsPerPage: 10,
  paging: false,
  filtering: false,
  sorting: false,
  searching: false,
};
export class CbjDatatableComponent implements OnInit, OnDestroy {
  config: DatatableOptions;
  menuItems:  MenuItem[];
  wWidth: number;
  colsHidden: boolean;

  columns: DatatableColumn[] = [];
  rows = [];
  visibleRows = [];
  pageNum = 0;
  pageCount = 1;
private multiData: DatatableMultiData[];
private multiColumns: DatatableColumn[][];
private unsubscribe: Subject<void> = new Subject();
/**
 * @param {?} http
 * @param {?} scroll
 * @param {?} ws
 */
constructor(private http: HttpClient,
private scroll: ScrollbarService,
private ws: WindowService) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.config = {
      ...DEFAULTS,
      ...this.config
    };
    this.initCols();
    this.initRows();
    this.measure();
    this.ws.resizeObs.takeUntil(this.unsubscribe).subscribe(this.measure);
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
private measure = () => {
    this.wWidth = this.ws.width;
    this.colsHidden = false;
    for (const /** @type {?} */ col of this.columns) {
      if (col.breakpoint) {
        col.hidden = col.breakpoint >= this.wWidth;
        if (col.hidden) {
          this.colsHidden = true;
        }
      }
    }
  }
/**
 * @return {?}
 */
private initCols() {
    if (this.config.multiData) {
      if (this.config.columns[0] instanceof Array) {
        for (const /** @type {?} */ col of /** @type {?} */(( <DatatableColumn[]>this.config.columns[0]))) {
          this.pushCol(col);
        }
        this.multiColumns = /** @type {?} */(( <DatatableColumn[][]>this.config.columns));
      } else {
        for (const /** @type {?} */ col of /** @type {?} */(( <DatatableColumn[]>this.config.columns))) {
          this.pushCol(col);
        }
      }
      this.multiData = /** @type {?} */(( <DatatableMultiData[]>this.config.data));
      this.initMenu();
    } else {
      for (const /** @type {?} */ col of /** @type {?} */(( <DatatableColumn[]>this.config.columns))) {
        this.pushCol(col);
      }
    }
  }
/**
 * @return {?}
 */
private initRows() {
    if (typeof this.config.data === 'string') {
      this.setAjaxRows(this.config.data, 0);
    }else {
      if (this.config.multiData) {
        if (typeof this.config.data[0].data === 'string')  {
          this.setAjaxRows(this.config.data[0].data, 0);
        } else {
          this.rows = this.config.data[0].data;
          this.setPaging(0);
          this.initVisibleRows();
        }
      }else {
        this.rows = this.config.data;
        this.setPaging(0);
        this.initVisibleRows();
      }
    }
  }
/**
 * @return {?}
 */
private initVisibleRows() {
    this.visibleRows = [];
    const /** @type {?} */ count = this.config.paging ? this.config.rowsPerPage : this.rows.length;
    let /** @type {?} */ offset = 0;
    if (this.config.paging) {
      offset = this.pageNum === 0 ? 0 : this.config.rowsPerPage * this.pageNum;
    }
    for (let /** @type {?} */ i = offset; i < count; i++) {
      const /** @type {?} */ row = this.rows[i];
      row.cbjState = 'closed';
      this.visibleRows.push(row);
    }
  }
/**
 * @return {?}
 */
private initMenu() {
    this.menuItems = [];
    let /** @type {?} */ i = 0;
    for (const /** @type {?} */ data of this.multiData) {
      this.menuItems.push({
        id: i,
        title: data.name,
        active: false,
        click: this.changeData
      });
      i++;
    }
  }
/**
 * @param {?} url
 * @param {?} pageNum
 * @return {?}
 */
private setAjaxRows(url: string, pageNum: number) {
    this.http.get(url).subscribe((resp: any) => {
      this.rows = resp;
      this.setPaging(pageNum);
      this.initVisibleRows();
    });
  }
/**
 * @param {?} pageNum
 * @return {?}
 */
private setPaging(pageNum: number) {
    if (this.rows.length > this.config.rowsPerPage && pageNum === 0) {
      this.config.paging = true;
      this.pageCount = Math.ceil(this.rows.length / this.config.rowsPerPage);
    }
    this.pageNum = pageNum;
  }
/**
 * @param {?} col
 * @return {?}
 */
pushCol(col: DatatableColumn) {
    this.columns.push({
      name: col.name,
      data: col.data,
      breakpoint: col.breakpoint === undefined ? undefined : col.breakpoint,
      keys: col.keys === undefined ? undefined : col.keys,
      flex: col.flex === undefined ? 1 : col.flex,
      sortable: col.sortable === undefined ? true : col.sortable,
      filterable: col.filterable === undefined ? true : col.filterable,
      searchable: col.searchable === undefined ? true : col.searchable,
      sortOrd: col.sortOrd ? col.sortOrd : 'asc',
      sorted: false,
      hidden: col.breakpoint === undefined ? false : col.breakpoint <= this.wWidth
    });
  }
/**
 * @param {?} subject
 * @return {?}
 */
isString(subject: any): boolean {
    return typeof subject === 'string';
  }

  changeData = (item: any) => {
    if (this.config.columns[0] instanceof Array) {
      this.columns = this.multiColumns[item.id];
    }
    if (typeof this.config.data[item.id].data === 'string')  {
      this.setAjaxRows(this.config.data[item.id].data, 0);
    } else {
      this.rows = this.config.data[item.id].data;
      this.setPaging(item.id);
      this.initVisibleRows();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-datatable',
  template: `
    <div class="card" [ngClass]="config.cardClasses">

        <div *ngIf="config.multiData || config.title" class="dtTitle">
            <ng-container *ngIf="config.multiData; else singleTitle">
                <cbj-menu [options]="{arrow: true, title: false}" [items]="menuItems"></cbj-menu>
            </ng-container>
            <ng-template #singleTitle>
                <h4>{{config.title}}</h4>
            </ng-template>
        </div>

        <div class="dtTable" [ngClass]="config.classes">

            <div class="dtTable-row dtTable-header">
                <ng-container *ngFor="let col of columns">
                    <ng-container *ngIf="!col.hidden">
                        <div class="dtTable-row-cell"
                             [ngStyle]="{'flex-grow': col.flex}"
                        >
                            {{col.name}}
                            <ng-container *ngIf="col.sortable">
                                <i *ngIf="col.sorted; else notSorted" class="material-icons md-success md-1" [ngClass]="col.sortOrd === 'desc' ? 'down' : ''">arrow_upward</i>
                                <ng-template #notSorted>
                                    <i class="material-icons md-1"></i>
                                </ng-template>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="colsHidden">
                    <div class="dtTable-row-cell" [ngStyle]="{'flex-shrink': 1}">
                        More
                    </div>
                </ng-container>
            </div>

            <div *ngFor="let row of visibleRows" class="dtTable-row">
                <ng-container *ngFor="let col of columns">
                    <div *ngIf="!col.hidden"
                         class="dtTable-row-cell"
                         [ngStyle]="{'flex-grow': col.flex}">

                        <ng-container *ngIf="isString(col.data); else compCell">
                            <span [innerHTML]="row[col.data]"></span>
                        </ng-container>
                        <ng-template #compCell>
                            <ng-template [cbjCompCell]="{row: row, component: col.data, keys: col.keys}"></ng-template>
                        </ng-template>

                    </div>
                </ng-container>
                <ng-container *ngIf="colsHidden">
                    <div class="dtTable-row-cell">
                        <div class="toggler" (click)="row.cbjState = row.cbjState === 'closed' ? 'open' : 'closed'">
                            <i class="material-icons tiny md-primary">add_box</i>
                        </div>
                    </div>
                    <div class="dtTable-row-hidden" [@collapse]="row.cbjState">
                        <ul class="cols-list">
                            <ng-container *ngFor="let col of columns">
                                <li *ngIf="col.hidden && isString(col.data)" class="col"><span class="col-name">{{col.name}}: </span><span [innerHTML]="row[col.data]"></span></li>
                            </ng-container>
                        </ul>
                    </div>
                </ng-container>
            </div>


            <div *ngIf="config.paging" class="card-footer dtTable-footer">
                <nav class="" aria-label="Demo Table Navigation">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="page-link" href="#" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Previous</span>
                            </a>
                        </li>
                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                        <li class="page-item">
                            <a class="page-link" href="#" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span class="sr-only">Next</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
  `,
  animations: [collapse(250, 'ease-in-out')]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ScrollbarService, },
{type: WindowService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'config': [{ type: Input, args: ['config', ] },],
};
}

function CbjDatatableComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjDatatableComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjDatatableComponent.ctorParameters;
/** @type {?} */
CbjDatatableComponent.propDecorators;
/** @type {?} */
CbjDatatableComponent.prototype.config;
/** @type {?} */
CbjDatatableComponent.prototype.menuItems;
/** @type {?} */
CbjDatatableComponent.prototype.wWidth;
/** @type {?} */
CbjDatatableComponent.prototype.colsHidden;
/** @type {?} */
CbjDatatableComponent.prototype.columns;
/** @type {?} */
CbjDatatableComponent.prototype.rows;
/** @type {?} */
CbjDatatableComponent.prototype.visibleRows;
/** @type {?} */
CbjDatatableComponent.prototype.pageNum;
/** @type {?} */
CbjDatatableComponent.prototype.pageCount;
/** @type {?} */
CbjDatatableComponent.prototype.multiData;
/** @type {?} */
CbjDatatableComponent.prototype.multiColumns;
/** @type {?} */
CbjDatatableComponent.prototype.unsubscribe;
/** @type {?} */
CbjDatatableComponent.prototype.measure;
/** @type {?} */
CbjDatatableComponent.prototype.changeData;
/** @type {?} */
CbjDatatableComponent.prototype.http;
/** @type {?} */
CbjDatatableComponent.prototype.scroll;
/** @type {?} */
CbjDatatableComponent.prototype.ws;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
